import { arrayOf, shape, string } from 'prop-types'

export const footerLinkType = shape({
  text: string.isRequired,
  href: string.isRequired,
})

export const footerLinksType = shape({
  help: arrayOf(footerLinkType).isRequired,
  company: arrayOf(footerLinkType).isRequired,
  legal: arrayOf(footerLinkType).isRequired,
})
